import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TvLiveComponent } from './tv-live.component';
import { TvLivePageComponent } from './tv-live-page/tv-live-page.component';
import { PipesModule } from 'app/_pipes/pipes.module';
import { SharedModule } from 'app/components/shared.module';
import { TvLiveRoutingModule } from './tv-live-routing.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

@NgModule({
  declarations: [
    TvLiveComponent,
    TvLivePageComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    PipesModule,
    TvLiveRoutingModule,
    InfiniteScrollModule,
  ],
  exports: [
    TvLiveComponent
  ]
})
export class TvLiveModule { }
